/* eslint-disable camelcase */
import $ from 'jquery';
import TesViewModel from './viewmodels/tesviewmodel';
import elementIntersectionObserver from '../../../dom/elementintersectionobserver';
import handleSelectedProduct from './handleselectedproduct';
import imageManager from './imagemanager';
import ko from 'knockout';
import lazyLoadVideo from '../../../lazyloadvideo';
import {lazybvshow, initializeBVReviewClick} from '../shared/lazybvshow';
import {productsOnPage} from '../../../vendor/googletagmanager/events';
import {returnsModalEventListener} from '../../shared/returnsmodal';
import {getUserLocation} from '../../../vendor/dynamicyield/dynamicyield';
import handleRestrictions from '../shared/ordercontrolrestrictions';
import {restrictions} from './ordercontrolrestrictions';
import spViewItem from '../../../vendor/googletagmanager/spevents/spviewitem';

const cookie = smartPak.cdProfileCookie,
    config = {
        discipline: cookie && cookie.PrimaryDiscipline ? cookie.PrimaryDiscipline.toLowerCase() : '',
        isPerksEligible: smartPak.smartPrimeCookie.PerksEligible === 'True'
    },
    $container = document.getElementById('productClassCon');

if (window.productClassData && $container) {
    window.productClassData.url = location.pathname;
    window.smartPak.pageData.productId = window.productClassData.id;

    productsOnPage([
        {
            name: window.productClassData.name.trim(),
            productClassId: window.productClassData.id,
            itemId: window.productClassData.itemNumber
        }
    ]);

    const $imageControl = $container.querySelector('#image-control'),
        productClassViewModel = (smartPak.productClassViewModel = new TesViewModel(window.productClassData, config));

    if ($imageControl) {
        imageManager.init($imageControl, productClassViewModel);
    }

    getUserLocation().then(geoFields => {
        productClassViewModel.userDetectedLocation(geoFields);
    });

    ko.applyBindings(productClassViewModel, $container);

    const $orderForm = $container.querySelector('#addSupplyForm'),
        observe = elementIntersectionObserver();
    const reviewStars = document.getElementById('productInfoStars');

    if ($orderForm) {
        observe($orderForm, () => {
            import('../shared/orderform').then(({default: orderForm}) =>
                orderForm.init($($orderForm), productClassViewModel)
            );
        });
    }

    if (productClassViewModel.selectedProduct()) {
        handleSelectedProduct();
    } else {
        productClassViewModel.selectedProduct.subscribe(product => {
            if (product) {
                handleSelectedProduct();
            }
        });
    }

    spViewItem({
        item_name: productClassViewModel.name(),
        item_id: productClassViewModel.itemNumber(),
        item_brand: productClassViewModel.manufacturer(),
        item_parent_reporting_category: productClassViewModel.parentReportingCategory(),
        item_child_reporting_category: productClassViewModel.childReportingCategory(),
        price: productClassViewModel.products()[0]?.price?.current()
    });

    handleRestrictions(productClassViewModel, restrictions);
    import('./belowthefold').then(({default: belowTheFold}) => belowTheFold(productClassViewModel, observe));

    lazybvshow();
    lazyLoadVideo();
    initializeBVReviewClick(reviewStars);
    returnsModalEventListener();
}
